var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.options),function(item,index){return [(_vm.values.includes(item.value))?[_c('span',{key:item.value,attrs:{"index":index}},[_vm._v(_vm._s(item.label + ' ')+" ")])]:_vm._e()]}),(_vm.unmatch && _vm.showValue)?[_vm._v(" "+_vm._s(_vm._f("handleArray")(_vm.unmatchArray))+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }